<section
	class="SummaryPanel"
	[class.SummaryPanel--compact]="density() === 'compact'"
>
	@if (title() && showTitle()) {
		<h3 class="SummaryPanel__title">{{ title() }}</h3>
	}

	@if (sections().length) {
		<div class="SummaryPanel__sections">
			@for (section of sections(); track section.title) {
				<div class="SummaryPanel__section">
					<h4 class="SummaryPanel__section-title">{{ section.title }}</h4>
					<ng-container
						[ngTemplateOutlet]="rowsTemplate"
						[ngTemplateOutletContext]="{ rows: section.rows }"
					/>
				</div>
			}
		</div>
	} @else {
		<ng-container
			[ngTemplateOutlet]="rowsTemplate"
			[ngTemplateOutletContext]="{ rows: rows() }"
		/>
	}

	<ng-template #rowsTemplate let-rows="rows">
		<div class="SummaryPanel__list">
			@for (row of rows; track $index) {
				<div class="SummaryPanel__row" [class.SummaryPanel__row--status]="row.status">
					@if (row.status) {
						<span class="SummaryPanel__status-label">{{ row.cells[0].label }}</span>
						<app-icon
							class="SummaryPanel__status-icon"
							[class.SummaryPanel__status-icon--error]="row.status === 'error'"
							[icon]="row.status === 'ok' ? EIcons.circleCheckSolid : EIcons.circleXmarkSolid"
							iconSize="small"
						/>
					} @else {
						@for (cell of row.cells; track $index) {
							<div
								class="SummaryPanel__cell"
								[class.SummaryPanel__cell--status]="cell.status"
							>
								<span class="SummaryPanel__label">{{ cell.label }}</span>
								@if (cell.status) {
									<app-icon
										class="SummaryPanel__status-icon"
										[class.SummaryPanel__status-icon--error]="cell.status === 'error'"
										[icon]="
											cell.status === 'ok'
												? EIcons.circleCheckSolid
												: EIcons.circleXmarkSolid
										"
										iconSize="small"
									/>
								} @else {
									<span class="SummaryPanel__value">{{ cell.value }}</span>
								}
							</div>
						}
					}
				</div>
			}
		</div>
	</ng-template>
</section>
